module.exports = {
  // 请输入表名按回车查询
  pleaseEnterTableName: 'Please enter the table name and press Enter to query',
  // 请上传文件
  pleaseUploadFile: 'Please Upload File',
  // 请上传图片
  pleaseUploadAPicture: 'Please Upload A Picture',
  // 请输入部门名称按回车进行搜索
  searchDept: 'Please enter the department name and press Enter to search',
  // 请上传
  pleaseUpload: 'Please Upload',
  // 普通同步
  normalSync: 'Normal synchronization (retain table data)',
  // 强制同步
  forceSync: 'Force sync (drop table, rebuild)',
  // 请确认
  pleaseConfirm: 'Please Confirm?',
  // 移除只会删除表单配置、删除会删除对应的数据库表
  confirmRemove: 'Remove will only delete the form configuration, delete will delete the corresponding database table',
  // 请选中该表对应的主表生成代码
  pleaseSelectMainTable: 'Please select the main table corresponding to the table to generate code',
  // 请先同步数据库
  pleaseSynchronizeTheDatabaseFirst: 'Please Synchronize The Database First',
  // 该浏览器不支持自动复制
  thisBrowserDoesNotSupportAutomaticCopying: 'This Browser Does Not Support Automatic Copying',
  // 复制成功
  copySuccessfully: 'Copy Successfully',
  // 请选择当前页数据
  pleaseSelectCurrentPageData: 'Please Select Current Page Data',
  // 确认要移除此记录
  confirmToRemoveThisRecord: "Are you sure to remove this record",
  // 菜单链接
  menuLink: 'menuLink',
  // 已同步
  synced: 'synced',
  // 未同步
  notSynced: 'notSynced',
  // 确定生成视图吗
  areYouSureGenerateTheView: 'Are you sure you want to generate the view？',
  areYouSureDeleteItem: 'Are you sure you want to delete {num} item?',//确定要删除此部门以及子节点数据吗
  // 请输入开始
  pleaseEnterStart: 'please enter to start',
  // 请输入结束
  pleaseEnterEnd: 'please enter the end',
  startUpload: 'Start Upload', // 开始上传
  uploading: 'Uploading...', // 上传中
  queDingFaBuMa: 'Are you sure to publish',
  queDingCheXiaoMa: 'confirmToRemoveThisRecord',
  zuihouyiye: 'This is the last page. You can not close it anymore',//这是最后一页，不能再关闭了啦
  shouyebunengguanbi: 'Home page cannot be closed',//首页不能关闭
  loginTitle: 'Login with account and password', // 账号密码登陆
  dragVerify: 'Drag slider to verify', // 拖动滑块验证
  dragSuccess: 'Verification passed', // 验证通过
  automaticLogin: 'Automatic login', // 自动登陆
  pleaseInput: 'Please input ', // 请输入
  pleaseSelect: 'Please select ', // 请选择
  confirmDeletion: 'Confirm deletion', // 确认删除
  deleteTheSelectedData: 'Delete the selected data?', // 是否删除选中数据
  selected: 'Selected', // 已选择
  term: ' term', // 项
  up: 'up', // 收起
  down: 'down', // 展开
  total: 'total', // 共
  article: 'article', // 条
  pleaseSet: 'please set ', // 请设置
  isSubmit: 'Confirm to submit?', // 确认提交吗?
  isWriteOff: 'Confirm to write off?', // 确定冲销吗?
  isDelete: 'Confirm to delete?', // 确定删除吗?
  isSynchronize: 'Confirm to synchronize?', // 确定同步吗?
  isCancel: 'Confirm to cancel?', // 确定取消吗?
  isEnable: 'Confirm to enable?', // 确定启用吗?
  isDisable: 'Confirm to disable?', // 确定禁用吗?
  mustBeGreaterThan0: ' must be greater than 0', // 必须大于0
  mustBeGreaterThanOrEqualToZeroInteger: ' must be greater than or equal to zero integer', // 必须为大于等于零整数
  mustBeAPositiveInteger: ' must be a positive integer', // 必须为正整数
  mustBeAnInteger: ' must be an integer', // 必须为整数
  filledInUpTo10Characters: ' can be filled in up to 10 characters', // 最多填写10个字符
  cannotBeEmpty: ' cannot be empty', // 不能为空
  mustBeLessThanOneDecimalPlaces: ' must be less than one decimal places', // 必须少于一位小数
  mustBeLessThanTwoDecimalPlaces: ' must be less than two decimal places', // 必须少于两位小数
  mustBeLessThanThreeDecimalPlaces: ' must be less than three decimal places', // 必须少于三位小数
  mustBeAPositiveFntegerFrom1To12: ' must be a positive integer from 1-12', // 必须为1-12正整数
  pleaseFillInTheInformationCompletely: 'Please fill in the information completely!', // 请将信息填写完整！
  successfulOperation: 'Successful operation', // 操作成功
  noData: 'No Data', // 暂无数据
  fileUploadSuccessful: 'File upload successful', // 文件上传成功
  fileUploadFailed: 'File upload failed', // 文件上传失败
  fileDownloadFailed: 'File download failed', // 文件下载失败
  none: 'None', // 无
  addAtLeastOneItemizedQuantity: 'Add at least one itemized quantity!', // 至少添加一条明细的数量！
  confirmSubmission: 'Confirm submission', // 确认提交
  whetherToSubmitTheSelectedData: 'Whether to submit the selected data', // 是否提交选中数据
  tips: 'Tips', // 提示
  YouDoNotBelongToTheDepartmentPleaseConfirmTheAccountInformation: 'You do not belong to the Department, please confirm the account information', // 您尚未归属部门,请确认账号信息
  currentOrganizationalStructureWillBeDocumented: 'The current organizational structure will be documented when the release is made', // 发布版本的同时会将当前组织架构进行记录
  importantOperations: 'Important operations', // 重要操作
  pleaseSelectDepartmentFirst: 'Please select a department first', // 请先选择一个部门
  areYouSureYouWantToLogOff: 'Are you sure you want to log off?', // 真的要注销登录吗?
  error: 'Error', // 错误
  refreshCacheCompleted: 'Refresh cache completed!', // 刷新缓存完成！
  failedToRefreshCache: 'Failed to refresh cache!', // 刷新缓存失败！
  sureToAbandonEditing: 'Sure to abandon editing?', // 确定放弃编辑？
  restoreUser: 'Restore user', // 恢复用户
  areYouSureRestore: 'Are you sure you want to restore', // 您确定要恢复
  users: 'users', // 用户
  deleteCompletely: 'Delete completely',// 彻底删除
  areYouSureDelete: 'Are you sure you want to delete', // 您确定要彻底删除
  notePleaseBeCarefulItCannotBeRecoveredAfterDeletion: 'Note: Please be careful as it cannot be recovered after complete deletion.', // 注意：彻底删除后将无法恢复，请谨慎操作！
  restore: 'Restore', // 还原
  delete: 'Delete', // 删除
  successfully: 'successfully', // 成功
  yourPhoneNumberIncorrect: 'Your cell phone number is not in the correct format', // 您的手机号码格式不正确
  currentSelection: 'Current selection', // 当前选择
  orgCodeAlreadyExists: 'Organization code already exists', // 机构编码已存在
  pleaseSelectARecord: 'Please select a record',// 请选择一条记录
  pleaseChooseToModify: 'Please click to select the department you want to modify', // 请点击选择要修改部门
  failureOperation: 'failure Operation', // 操作成功
  areYouSureDeleteDepartmentAndSubData: 'Are you sure you want to delete this department and its sub-node data?',//确定要删除此部门以及子节点数据吗
  pleaseSelectParentDepartment: 'Please click first to select the parent department!', //请先点击选中上级部门
  dataAndSubData: 'data, as well as sub-node data?', // n条数据，及子数据
  confirmTheApproval: 'confirm the approval',//确认审核通过
  determineThePlanToReject: 'Determine the plan to reject',//确定计划驳回
  determinedToVoid: 'Determined to void!',//确定作废
  details: 'details', // 详情
  mustBeGreaterThanOrEqualTo: 'must be greater than or equal to 0',//必须大于等于0
  mustBeLessThanFourDecimalPlaces: 'must be less than four decimal places',//必须少于四位小数
  mustBeLessThanSixDecimalPlaces: 'must be less than six decimal places',//必须少于六位小数
  mustBeOrPositiveInteger: 'must be or positive integer',//必须是或者正整数
  rejected: 'Rejected!',//确定驳回
  contractBreakdownSheetFailedTo: 'Contract breakdown sheet failed to',//合同明细表单校验未通过
  confrimSynchronization: 'Confrim synchronization?',//确定同步
  makeSureTheReviewIsApproved: 'Make sure the review is approved',//确定审核通过
  confirmRejection: 'Confirm rejection',//确定计划驳回
  confirmToVoid: 'Confirm to void',//确定作废
  okToUpdateTheStatement: 'OK to update the statement',//确定更新结算单
  okToWithdraw: 'OK to withdraw?',//确定撤回吗
  theHighestPriceCannotBeLessThanTheLowestPrice: 'The highest price cannot be less than the lowest price',//最高价不能小于最低价
  lowestPriceCannotBeGreaterThanTheHighestPrice: 'Lowest price cannot be greater than the highest price',//最低价不能大于最高价
  mustBe0OrAPositiveInteger: 'Must be 0 or a positive integer',//必须为0或正整数
  theDataIsNotFilledInCompletelyPleaseCheck: 'The data is not filled in completely, please check',//数据没有填完整,请检查
  theBatchDoesNotHaveTheDeliveryInformation: 'The batch does not have the delivery information',//该批次没有出栏信息
  noConsumptionInformationForThisBatch: 'No consumption information for this batch',//该批次没有耗用信息
  theVerificationOfTheBatchDetailsDidNotPass: 'The verification of the batch details did not pass',//出栏明细校验未通过
  feedingBatchNeedsToBeSelected: 'Feeding batch needs to be selected',//饲养批次需要选择
  marginFormCheckFailed: 'Margin form check failed',//保证金表单校验未通过
  departmentSwitching: 'Department Switching',//部门切换
  currentDepartment: 'Current Department',//当前部门
  pleaseSelectSettlementBatchNumber: 'Please Select Settlement Batch Number'//请选择结算批次编号
}